import React, { useState } from "react";
import { Table, Container, Input, Row, Col, Form, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import Swal from "sweetalert2";
import { TfiDownload } from "react-icons/tfi"
import { TbFileImport } from "react-icons/tb"
import { NumberWithCommas } from "../../share/NumberWithCommas";


export function Report19202() {

    const [selectStatus, setSelectStatus] = React.useState(101);

    let hidetable = true;
    let hidetable2 = true;
    let hidetable3 = true;
    let hidetable4 = true;
    let hidetable5 = true;
    let hidetable6 = true;
    let hidetable7 = true;
    let hidetable8 = true;
    let hidetable9 = true;
    let hidetable10 = true;
    let hidetable11 = true;
    let hidetable12 = true;
    let hidetable13 = true;


    if (selectStatus === 1) {
        hidetable = false;
    }
    if (selectStatus === 2) {
        hidetable2 = false;
    }
    if (selectStatus === 11) {
        hidetable3 = false;
    }
    if (selectStatus === 12) {
        hidetable4 = false;
    }
    if (selectStatus === 10) {
        hidetable5 = false;
    }
    if (selectStatus === 13) {
        hidetable6 = false;
    }
    if (selectStatus === 14) {
        hidetable7 = false;
    }
    if (selectStatus === 4) {
        hidetable8 = false;
    }
    if (selectStatus === 3) {
        hidetable9 = false;
    }
    if (selectStatus === 7) {
        hidetable10 = false;
    }
    if (selectStatus === 15) {
        hidetable11 = false;
    }
    if (selectStatus === 16) {
        hidetable12 = false;
    }
    if (selectStatus == 101 || selectStatus == 102 || selectStatus == 103 || selectStatus == 104 || selectStatus == 105 || selectStatus == 106 || selectStatus == 107 || selectStatus == 108 || selectStatus == 109) {
        hidetable13 = false;
    }

    const [Re19202data, setRe19202data] = useState([]);
    const [Re192022data, setRe192022data] = useState([]);
    const [Re192023data, setRe192023data] = useState([]);
    const [Re192024data, setRe192024data] = useState([]);
    const [Re192025data, setRe192025data] = useState([]);
    const [Re192026data, setRe192026data] = useState([]);
    const [Re192027data, setRe192027data] = useState([]);
    const [Re192028data, setRe192028data] = useState([]);
    const [Re192029data, setRe192029data] = useState([]);
    const [Re1920210data, setRe1920210data] = useState([]);
    const [Re1920211data, setRe1920211data] = useState([]);
    const [Re1920212data, setRe1920212data] = useState([]);
    const [ReNewdata, setReNewdata] = useState([]);




    async function getR19202() {
        const formData = new FormData();
        formData.append("status", selectStatus);
        const res = await fetch("/api/BorrowReports/getReportAccDept", {
            method: 'POST',
            body: formData
        })
        const Re19202data = await res.json()
        setRe19202data(Re19202data.dataenum)
        console.log(Re19202data)
    }
    async function getR192022() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res192022 = await fetch("/api/BorrowReports/getV192022", {
            method: 'POST',
            body: formData
        })
        const Re192022data = await res192022.json()
        setRe192022data(Re192022data.dataenum)
        console.log(Re192022data)
    }
    async function getR192023() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res192023 = await fetch("/api/BorrowReports/getV192023", {
            method: 'POST',
            body: formData
        })
        const Re192023data = await res192023.json()
        setRe192023data(Re192023data.dataenum)
        console.log(Re192023data)
    }
    async function getR192024() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res192024 = await fetch("/api/BorrowReports/getV192024", {
            method: 'POST',
            body: formData
        })
        const Re192024data = await res192024.json()
        setRe192024data(Re192024data.dataenum)
        console.log(Re192024data)
    }
    async function getR192025() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res192025 = await fetch("/api/BorrowReports/getV192025", {
            method: 'POST',
            body: formData
        })
        const Re192025data = await res192025.json()
        setRe192025data(Re192025data.dataenum)
        console.log(Re192025data)
    }
    async function getR192026() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res192026 = await fetch("/api/BorrowReports/getV192026", {
            method: 'POST',
            body: formData
        })
        const Re192026data = await res192026.json()
        setRe192026data(Re192026data.dataenum)
        console.log(Re192026data)
    }
    async function getR192027() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res192027 = await fetch("/api/BorrowReports/getV192027", {
            method: 'POST',
            body: formData
        })
        const Re192027data = await res192027.json()
        setRe192027data(Re192027data.dataenum)
        console.log(Re192027data)
    }
    async function getR192028() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res192028 = await fetch("/api/BorrowReports/getV192028", {
            method: 'POST',
            body: formData
        })
        const Re192028data = await res192028.json()
        setRe192028data(Re192028data.dataenum)
        console.log(Re192028data)
    }
    async function getR192029() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res192029 = await fetch("/api/BorrowReports/getV192029", {
            method: 'POST',
            body: formData
        })
        const Re192029data = await res192029.json()
        setRe192029data(Re192029data.dataenum)
        console.log(Re192029data)
    }
    async function getR1920210() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res1920210 = await fetch("/api/BorrowReports/getV1920210", {
            method: 'POST',
            body: formData
        })
        const Re1920210data = await res1920210.json()
        setRe1920210data(Re1920210data.dataenum)
        console.log(Re1920210data)
    }
    async function getR1920211() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res1920211 = await fetch("/api/BorrowReports/getV1920211", {
            method: 'POST',
            body: formData
        })
        const Re1920211data = await res1920211.json()
        setRe1920211data(Re1920211data.dataenum)
        console.log(Re1920211data)
    }
    async function getR1920212() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res1920212 = await fetch("/api/BorrowReports/getV1920212", {
            method: 'POST',
            body: formData
        })
        const Re1920212data = await res1920212.json()
        setRe1920212data(Re1920212data.dataenum)
        console.log(Re1920212data)
    }

    async function getReNew() {
        const formData = new FormData();
        formData.append("thYear", selectStatus);
        const res = await fetch("/api/BorrowReports/getReNew", {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        if (selectStatus == 101) {
            setReNewdata(data.dataenum.filter(item => item.debtStatusId == 1))
        }
        if (selectStatus == 102) {
            setReNewdata(data.dataenum.filter(item => item.debtStatusId == 2))

        }
        if (selectStatus == 103) {
            setReNewdata(data.dataenum.filter(item => item.debtStatusId == 3))

        }
        if (selectStatus == 104) {
            setReNewdata(data.dataenum.filter(item => item.debtStatusId == 4))

        }
        if (selectStatus == 105) {
            setReNewdata(data.dataenum.filter(item => item.debtStatusId == 5))

        }
        if (selectStatus == 106) {
            setReNewdata(data.dataenum.filter(item => item.debtStatusId == 6))

        }
        if (selectStatus == 107) {
            setReNewdata(data.dataenum.filter(item => item.debtStatusId == 7))

        }
        if (selectStatus == 108) {
            setReNewdata(data.dataenum.filter(item => item.debtStatusId == 8))

        }
        if (selectStatus == 109) {
            setReNewdata(data.dataenum.filter(item => item.debtStatusId == 9))

        }
        // console.log(Re1920212data)
    }



    React.useEffect(() => {
        getR19202()
        getR192022()
        getR192023()
        getR192024()
        getR192025()
        getR192026()
        getR192027()
        getR192028()
        getR192029()
        getR1920210()
        getR1920211()
        getR1920212()
        getReNew();
    }, [selectStatus]);

    const [thYearSelected, setThYearSelected] = useState(1);
    const [fileInput, setFileInput] = useState(null);
    const [fileError, setFileError] = useState(null);
    const [openModalFileForm, setOpenModalFileForm] = useState(false);
    const modalFileToggle = () => setOpenModalFileForm(!openModalFileForm);


    const importFileSubmit = async (e) => {
        e.preventDefault();
        if (fileInput) {
            let postData = new FormData()
            postData.append("file", fileInput)
            postData.append("idtable", thYearSelected)
            let res = await fetch("/api/BorrowReports/getUpload19202", {
                method: "POST",
                body: postData
            })
            let resJson = await res.json()
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "นำเข้าข้อมูลสำเร็จ",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                })
                modalFileToggle();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "นำเข้าข้อมูลไม่สำเร็จ",
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        }
        else {
            Swal.fire({
                icon: "info",
                title: "กรุณาแนบไฟล์",
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            })
        }
    }



    const handleFileInputChange = (e) => {
        const file = e.target.files[0];
        const allowedTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        const maxSize = 10000000; // 10 MB

        if (file && !allowedTypes.includes(file.type)) {
            setFileError('รองรับเฉพาะไฟล์ excel');
            setFileInput(null);
        } else if (file && file.size > maxSize) {
            setFileError('ขนาดไฟล์ต้องไม่เกิน 10 MB');
            setFileInput(null);
        } else {
            setFileError(null);
            setFileInput(file);
        }

    }
    /////////////////////////////////////////////////////////////////////////////////////
    const [comnoSelected, setcomnoSelected] = useState(1);
    // const [filetext, setFiletext1] = useState(null);
    const [fileError1, setFileError1] = useState(null);
    const [comno, setcomno1] = useState();

    const [openModalFileForm1, setOpenModalFileForm1] = useState(false);
    const modalFileToggle1 = () => setOpenModalFileForm1(!openModalFileForm1, comno);


    const importFileSubmit1 = async (e) => {
        e.preventDefault();
        let postData = new FormData()
        postData.append("comno", comno)
        postData.append("idcomno", comnoSelected)
        let res = await fetch("/api/BorrowReports/firstGetV19202", {
            method: "POST",
            body: postData
        })
        let resJson = await res.json()
        if (resJson.status === 1) {
            Swal.fire({
                icon: "success",
                title: "แก้ไขข้อมูลสำเร็จ",
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",

            }).then(
                function () { window.location.reload(); },
            );
            modalFileToggle1();


        } else {
            Swal.fire({
                icon: "error",
                title: "แก้ไขข้อมูลไม่สำเร็จ",
                text: `เนื่องจาก ${resJson.message}`,
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });
        }
    }





    return (
        <Container>
            <Form
                onSubmit={importFileSubmit}
            >

                <Modal
                    isOpen={openModalFileForm}
                    toggle={modalFileToggle}
                    centered
                    backdrop={"static"}
                    keyboard={false}
                >
                    <ModalHeader className="text-center" toggle={modalFileToggle}>นำเข้าข้อมูล</ModalHeader>
                    <ModalBody>
                        <Input
                            className="my-3 rounded-pill input-color"
                            type="file"
                            id="fileInput"
                            onChange={handleFileInputChange}
                        >
                        </Input>
                        <Input
                            className="rounded-pill input-color"
                            // style={{ borderColor: "#130558", width: "100%", margin: "auto", }}
                            id="othYear"
                            name="othYear"
                            type="select"
                            value={thYearSelected}
                            onChange={(e) => {
                                setThYearSelected(e.target.value)
                            }}
                        >
                            <option defaultValue value={1}>
                                1. รับชำระหนี้ก่อนพิพากษา
                            </option>
                            <option value={2}>
                                2. การประนอมหนี้
                            </option>
                            <option value={3}>
                                3. พิพากษา
                            </option>
                            <option value={4}>
                                4. ประนอมหนี้ภายหลังศาลมีคำพิพากษา
                            </option>
                            <option value={5}>
                                5. ปิดบัญชีแล้ว
                            </option>
                            <option value={6}>
                                6. ยังไม่ส่งฟ้องคดี (ลูกหนี้ของตนเอง)
                            </option>
                            <option value={7}>
                                7. ยังไม่ส่งฟ้องคดี (กรณีรับลูกหนี้จากหน่วยงานอื่นมาฟ้องคดีตามภูมิลำเนา)
                            </option>
                            <option value={8}>
                                8. ส่งฟ้องคดีแล้ว
                            </option>
                            <option value={9}>
                                9. ศาลมีคำพิพากษาแล้ว
                            </option>
                            <option value={11}>
                                10. ส่งฟ้องแล้วแต่ศาลไม่รับฟ้อง
                            </option>
                            <option value={11}>
                                11. อยู่ระหว่างขั้นตอนการขออนุมัติตัดหนี้สูญ
                            </option>
                            <option value={12}>
                                12. กรมบัญชีกลางอนุมัติตัดหนี้สูญแล้ว
                            </option>
                            <option value={13}>
                                13. ลูกหนี้ตามสัญญากู้ยืมเงิน
                            </option>
                            <option value={14}>
                                14. ลูกหนี้ตามสัญญาประนอมหนี้
                            </option>
                            <option value={15}>
                                15. สัญญาประนีประนอมยอมความ (ชั้นอัยการ)
                            </option>
                            <option value={16}>
                                16. ลูกหนี้ส่งฟ้องคดีแล้วแต่ยังไม่มีคำพิพากษา (คดีดำ)
                            </option>
                            <option value={17}>
                                17. พิพากษาตามยอม (คดีแดง)
                            </option>
                            <option value={18}>
                                18. บังคับคดี
                            </option>

                        </Input>
                        {fileError && <span className="text-danger">{fileError}</span>}

                    </ModalBody>
                    <ModalFooter className="mt-2">
                        <button className="btn border-1 border" type="submit" onClick={(e) => { importFileSubmit(e) }}>ยืนยัน</button>
                        <button className="btn border-1 border" type="button" onClick={() => modalFileToggle(!openModalFileForm)}>ยกเลิก</button>
                    </ModalFooter>
                </Modal>
            </Form>

            <Form
                onSubmit={importFileSubmit1}
            >
                <Modal
                    isOpen={openModalFileForm1}
                    toggle={modalFileToggle1}
                    centered
                    backdrop={"static"}
                    keyboard={false}
                >
                    <ModalHeader className="styled-modal text-center" toggle={modalFileToggle1}>แก้ไข</ModalHeader>
                    <ModalBody>
                        <lable>เลขที่สัญญา</lable>
                        <Input
                            className="rounded-pill input-color"
                            type="text"
                            id="filetext"
                            value={comno}
                        >
                        </Input>
                        <br></br>
                        <Input
                            className="rounded-pill input-color"
                            //style={{ borderColor: "#130558", width: "100%", margin: "auto", }}
                            id="comno1"
                            name="comno1"
                            type="select"
                            value={comnoSelected}
                            onChange={(e) => {
                                setcomnoSelected(e.target.value)
                            }}
                        >
                            <option defaultValue value={1}>
                                6.1 ลูกหนี้ตามสัญญากู้ยืมเงิน
                            </option>
                            <option value={2}>
                                6.2 ลูกหนี้ตามสัญญาประนอมหนี้
                            </option>
                            <option value={3}>
                                6.3 สัญญาประนีประนอมยอมความ (ชั้นอัยการ)
                            </option>
                            <option value={4}>
                                6.4 ลูกหนี้ส่งฟ้องคดีแล้วแต่ยังไม่มีคำพิพากษา (คดีดำ)
                            </option>
                            <option value={5}>
                                6.5 พิพากษา พิพากษาตามยอม (คดีแดง)
                            </option>
                            <option value={6}>
                                6.6 พิพากษายกฟ้อง
                            </option>
                            <option value={7}>
                                6.7 อัยการแจ้งฐานะคดีไม่รับว่าต่างคดีให้
                            </option>
                            <option value={8}>
                                6.8 คณะกรรมการยุติการดำเนินคดีแพ่งของส่วนราชการ
                            </option>
                            <option value={9}>
                                6.9 บังคับคดี
                            </option>
                            <option value={10}>
                                6.10 ปิดบัญชี
                            </option>

                        </Input>
                        {fileError1 && <span className="text-danger">{fileError1}</span>}


                    </ModalBody>
                    <ModalFooter>
                        <button className="btn border-1 border" type="submit" onClick={(e) => { importFileSubmit1(e) }}>ยืนยัน</button>
                        <button className="btn border-1 border" type="button" onClick={() => modalFileToggle1(!openModalFileForm)}>ยกเลิก</button>
                    </ModalFooter>
                </Modal>
            </Form>


            <div>
                <div className="d-flex justify-content-center">
                    <Input
                        className="input-color rounded-pill text-left w-50"
                        // style={{ borderColor: "#130558", width: "100%", paddingTop: '0px', fontSize: '1.75rem' }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={selectStatus}
                        onChange={(e) => {
                            setSelectStatus(Number(e.target.value))
                        }}
                    >
                        {/* <option defaultValue value={1}>
                            1. รับชำระหนี้ก่อนพิพากษา
                        </option>
                        <option value={2}>
                            2. การประนอมหนี้
                        </option>
                        <option value={11}>
                            3. พิพากษา
                        </option>
                        <option value={12}>
                            4. ประนอมหนี้ภายหลังศาลมีคำพิพากษา
                        </option>
                        <option value={10}>
                            5. ปิดบัญชีแล้ว
                        </option>
                        <option value={13}>
                            6. ยังไม่ส่งฟ้องคดี (ลูกหนี้ของตนเอง)
                        </option>
                        <option value={14}>
                            7. ยังไม่ส่งฟ้องคดี (กรณีรับลูกหนี้จากหน่วยงานอื่นมาฟ้องคดีตามภูมิลำเนา)
                        </option>
                        <option value={4}>
                            8. ส่งฟ้องคดีแล้ว
                        </option>
                        <option value={3}>
                            9. ศาลมีคำพิพากษาแล้ว
                        </option>
                        <option value={7}>
                            10. ส่งฟ้องแล้วแต่ศาลไม่รับฟ้อง
                        </option>
                        <option value={15}>
                            11. อยู่ระหว่างขั้นตอนการขออนุมัติตัดหนี้สูญ
                        </option>
                        <option value={16}>
                            12. กรมบัญชีกลางอนุมัติตัดหนี้สูญแล้ว
                        </option> */}
                        <option value={101}>
                            1. ลูกหนี้ตามสัญญากู้ยืมเงิน
                        </option>
                        <option value={102}>
                            2. ลูกหนี้ตามสัญญาประนอมหนี้
                        </option>
                        <option value={103}>
                            3. สัญญาประนีประนอมยอมความ (ชั้นอัยการ)
                        </option>
                        <option value={104}>
                            4. ลูกหนี้ส่งฟ้องคดีแล้วแต่ยังไม่มีคำพิพากษา (คดีดำ)
                        </option>
                        <option value={105}>
                            5. พิพากษาตามยอม (คดีแดง)
                        </option>
                        <option value={106}>
                            6. พิพากษายกฟ้อง
                        </option>
                        <option value={107}>
                            7. พิพากษา
                        </option>
                        <option value={108}>
                            8. บังคับคดี
                        </option>
                        <option value={109}>
                            9. ปิดบัญชี
                        </option>
                    </Input>
                </div>
                <Row>
                    <Col className='d-flex justify-content-end my-3'>
                        <button
                            type="button"
                            className="btn-blue"
                            onClick={() => { modalFileToggle(!openModalFileForm) }}
                        >
                            <TbFileImport className="me-2" />
                            นำเข้าข้อมูลรายงาน
                        </button>
                        {/* <button
                            type="button"
                            className="btn-green ms-2 border border-1"
                            onClick={() => { modalFileToggle(!openModalFileForm) }}
                        >
                            <TfiDownload className="me-2"/>
                            ดาวน์โหลด Template
                        </button> */}
                    </Col>
                </Row>

                {/* รับชำระหนี้ก่อนพิพากษา*/}
                <Table hidden={hidetable} className="styled-table" bordered responsive striped hover >
                    <thead>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วงเงินทำสัญญา
                            </th>
                            <th colSpan="8" className='text-center'>
                                1.รับชำระหนี้ก่อนพิพากษา
                            </th>
                            <th rowSpan="2" className='text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                เงินต้น
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ดอกเบี้ย
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เบี้ยปรับ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ค่าฤชาธรรมเนียม
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เงินรอจ่ายคืน
                            </th>
                            <th rowSpan="2" className='text-center'>
                                รายได้อื่น
                            </th>
                            <th rowSpan="2" className='text-center'>
                                รวม
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เงินต้นค้างชำระ
                            </th>

                        </tr>

                    </thead>
                    <tbody>
                        {Re19202data.length > 0 && Re19202data.map((item, i) => (
                            <tr >
                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>
                                <td className='text-end'>
                                    {item.amount}
                                </td>

                                <td className='text-end'>
                                    {item.interate}
                                </td>
                                <td className='text-end'>
                                    {item.fine}
                                </td>
                                <td className='text-end'>
                                    {item.fee}
                                </td>
                                <td className='text-end'>
                                    {item.payBack}
                                </td>
                                <td className='text-end'>
                                    {item.incomeOther}
                                </td>
                                <td className='text-end'>
                                    {item.total}
                                </td>
                                <td className='text-end'>
                                    {item.outstanding}
                                </td>
                                <td className='text-end'>

                                </td>
                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>
                </Table>
                {/* การประนอมหนี้*/}
                <Table hidden={hidetable2} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="3" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="3" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="3" className='text-center'>
                                เลขที่สัญญา
                            </th>

                            <th rowSpan="3" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินทำสัญญา
                            </th>
                            <th colSpan="11" className='text-center'>
                                2.การประนอมหนี้
                            </th>
                            <th rowSpan="3" className='text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                เงินต้นตามสัญญาประนอมหนี้
                            </th>
                            <th colSpan="10" className='text-center'>
                                รับชำระหนี้ตามสัญญาประนอมหนี้
                            </th>
                        </tr>


                        <tr>
                            <th className='text-center'>
                                เงินต้น
                            </th>
                            <th className='text-center'>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center'>
                                เบี้ยปรับ
                            </th>
                            <th className='text-center'>
                                ค่าทนายความ
                            </th>
                            <th className='text-center'>
                                ค่าฤชาธรรมเนียม
                            </th>
                            <th className='text-center'>
                                ค่าใช้จ่ายในการดำเนินคดีในชั้นบังคับคดี
                            </th>
                            <th className='text-center'>
                                เงินรอจ่ายคืน
                            </th>
                            <th className='text-center'>
                                รายได้อื่น
                            </th>
                            <th className='text-center'>
                                รวม
                            </th>
                            <th className='text-center'>
                                เงินต้นค้างชำระ
                            </th>
                        </tr>

                    </thead>
                    <tbody>
                        {Re192022data.length > 0 && Re192022data.map((item, i) => (
                            <tr >
                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>
                                <td className='text-end'>
                                    {item.compDebtAmount}
                                </td>
                                <td className='text-end'>
                                    {item.amount}
                                </td>
                                <td className='text-end'>
                                    {item.interate}
                                </td>
                                <td className='text-end'>
                                    {item.fine}
                                </td>
                                <td className='text-end'>
                                    {item.lawyerFee}
                                </td>
                                <td className='text-end'>
                                    {item.fee}
                                </td>
                                <td className='text-end'>
                                    {item.lawCost}
                                </td>
                                <td className='text-end'>
                                    {item.payBack}
                                </td>
                                <td className='text-end'>
                                    {item.incomeOther}
                                </td>
                                <td className='text-end'>
                                    {item.total}
                                </td>
                                <td className='text-end'>
                                    {item.outstanding}
                                </td>

                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>

                </Table>
                {/* พิพากษา  */}
                <Table hidden={hidetable3} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="3" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="3" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="3" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินทำสัญญา
                            </th>
                            <th colSpan="10" className='text-center'>
                                3. พิพากษา
                            </th>
                            <th rowSpan="3" className='text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                เงินต้นตามคำพิพากษา
                            </th>
                            <th colSpan="9" className='text-center'>
                                รับชำระหนี้ตามคำพิพากษา
                            </th>
                        </tr>


                        <tr>
                            <th className='text-center'>
                                เงินต้น
                            </th>
                            <th className='text-center'>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center'>
                                เบี้ยปรับ
                            </th>
                            <th className='text-center'>
                                ค่าทนายความ
                            </th>
                            <th className='text-center'>
                                ค่าฤชาธรรมเนียม
                            </th>

                            <th className='text-center'>
                                เงินรอจ่ายคืน
                            </th>
                            <th className='text-center'>
                                รายได้อื่น
                            </th>
                            <th className='text-center'>
                                รวม
                            </th>
                            <th className='text-center'>
                                เงินต้นค้างชำระ
                            </th>
                        </tr>

                    </thead>
                    <tbody>
                        {Re192023data.length > 0 && Re192023data.map((item, i) => (
                            <tr >


                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>
                                <td className='text-end'>
                                    {item.judeAmount}
                                </td>
                                <td className='text-end'>
                                    {item.amount}
                                </td>
                                <td className='text-end'>
                                    {item.interate}
                                </td>
                                <td className='text-end'>
                                    {item.fine}
                                </td>
                                <td className='text-end'>
                                    {item.lawyerFee}
                                </td>
                                <td className='text-end'>
                                    {item.fee}
                                </td>
                                <td className='text-end'>
                                    {item.payBack}
                                </td>
                                <td className='text-end'>
                                    {item.incomeOther}
                                </td>
                                <td className='text-end'>
                                    {item.total}
                                </td>
                                <td className='text-end'>
                                    {item.outstanding}
                                </td>

                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>


                </Table>
                {/*  ประนอมหนี้ภายหลังศาลมีคำพิพากษา */}
                <Table hidden={hidetable4} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="3" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="3" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="3" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินทำสัญญา
                            </th>
                            <th colSpan="11" className='text-center'>
                                4. ประนอมหนี้ภายหลังศาลมีคำพิพากษา
                            </th>
                            <th rowSpan="3" className='text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                เงินต้นตามสัญญาประนอมหนี้ภายหลังศาลมีคำพิพากษา
                            </th>
                            <th colSpan="10" className='text-center'>
                                รับชำระหนี้ตามคำพิพากษา
                            </th>
                        </tr>


                        <tr>
                            <th className='text-center'>
                                เงินต้น
                            </th>
                            <th className='text-center'>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center'>
                                เบี้ยปรับ
                            </th>
                            <th className='text-center'>
                                ค่าทนายความ
                            </th>
                            <th className='text-center'>
                                ค่าฤชาธรรมเนียม
                            </th>
                            <th className='text-center'>
                                ค่าใช้จ่ายในการดำเนินคดีในชั้นบังคับคดี
                            </th>
                            <th className='text-center'>
                                เงินรอจ่ายคืน
                            </th>
                            <th className='text-center'>
                                รายได้อื่น
                            </th>
                            <th className='text-center'>
                                รวม
                            </th>
                            <th className='text-center'>
                                เงินต้นค้างชำระ
                            </th>
                        </tr>

                    </thead>
                    <tbody>
                        {Re192024data.length > 0 && Re192024data.map((item, i) => (
                            <tr >


                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>
                                <td className='text-end'>
                                    {item.compDebtJudeAmount}
                                </td>
                                <td className='text-end'>
                                    {item.amount}
                                </td>
                                <td className='text-end'>
                                    {item.interate}
                                </td>
                                <td className='text-end'>
                                    {item.fine}
                                </td>
                                <td className='text-end'>
                                    {item.lawyerFee}
                                </td>
                                <td className='text-end'>
                                    {item.fee}
                                </td>
                                <td className='text-end'>
                                    {item.lawCost}
                                </td>
                                <td className='text-end'>
                                    {item.payBack}
                                </td>
                                <td className='text-end'>
                                    {item.incomeOther}
                                </td>
                                <td className='text-end'>
                                    {item.total}
                                </td>
                                <td className='text-end'>
                                    {item.outstanding}
                                </td>

                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>

                </Table>
                {/*  ปิดบัญชีแล้ว */}
                <Table hidden={hidetable5} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วงเงินทำสัญญา
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วันที่ชำระครั้งสุดท้าย
                            </th>
                            <th colSpan="3" className='text-center'>
                                ปิดบัญชีแล้ว
                            </th>
                            <th rowSpan="2" className='text-center'>

                            </th>
                        </tr>

                        <tr>
                            <th className='text-center'>
                                การปิดบัญชี
                            </th>
                            <th className='text-center'>
                                เลขที่ใบเสร็จรับเงินที่ปิดบัญชี
                            </th>
                            <th className='text-center'>
                                วันที่ออกใบเสร็จรับเงินที่ปิดบัญชี
                            </th>

                        </tr>

                    </thead>
                    <tbody>
                        {Re192025data.length > 0 && Re192025data.map((item, i) => (
                            <tr >


                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>
                                <td className='text-end'>
                                    {item.lastPaymentDate}
                                </td>
                                <td className='text-end'>
                                    {item.accountClose}
                                </td>
                                <td className='text-end'>
                                    {item.asreceiptClose}
                                </td>
                                <td className='text-end'>
                                    {item.receiptCloseDate}
                                </td>
                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>

                </Table>
                {/*  ยังไม่ส่งฟ้องคดี ลูกหนี้ของตนเอง */}
                <Table hidden={hidetable6} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="3" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="3" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="3" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินทำสัญญา
                            </th>
                            <th colSpan="6" className='text-center'>
                                ยังไม่ส่งฟ้องคดี (ลูกหนี้ของตนเอง)
                            </th>
                            <th rowSpan="3" className='text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th colSpan="2" className='text-center'>
                                ยังไม่ส่งฟ้องคดี
                            </th>
                            <th colSpan="2" className='text-center'>
                                ประนอมหนี้ก่อนระเบียบฯ พ.ศ. 2555 (ผ่อนชำระ)
                            </th>
                            <th colSpan="2" className='text-center'>
                                ประนอมหนี้ตามระเบียบฯ 28/1 (2) (ผ่อนชำระ)
                            </th>
                        </tr>


                        <tr>
                            <th className='text-center'>
                                ยังไม่หมดอายุความ (ระบุเหตุผลที่ยังไม่ส่งฟ้อง)
                            </th>
                            <th className='text-center'>
                                หมดอายุความ (ให้ระบุว่าทำอะไรต่อ)
                            </th>
                            <th className='text-center'>
                                วันที่ประนอม
                            </th>
                            <th className='text-center'>
                                จำนวนเงิน
                            </th>
                            <th className='text-center'>
                                วันที่ประนอม
                            </th>
                            <th className='text-center'>
                                จำนวนเงิน
                            </th>

                        </tr>

                    </thead>
                    <tbody>
                        {Re192026data.length > 0 && Re192026data.map((item, i) => (
                            <tr >
                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>
                                <td className='text-end'>
                                    {item.lawNotExpired}
                                </td>
                                <td className='text-end'>
                                    {item.lawExpired}
                                </td>
                                <td className='text-end'>
                                    {item.compDebtDate}
                                </td>
                                <td className='text-end'>
                                    {item.compDebtAmount}
                                </td>
                                <td className='text-end'>
                                    {item.compDebtDate}
                                </td>
                                <td className='text-end'>
                                    {item.compDebtAmount}
                                </td>
                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>

                </Table>
                {/*  ยังไม่ส่งฟ้องคดี (กรณีรับลูกหนี้จากหน่วยงานอื่นมาฟ้อง) */}
                <Table hidden={hidetable7} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="3" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="3" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="3" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินทำสัญญา
                            </th>
                            <th rowSpan="3" className='text-center'>
                                หน่วยงานที่ฟ้องคดี
                            </th>
                            <th colSpan="8" className='text-center'>
                                ยังไม่ส่งฟ้องคดี (กรณีรับลูกหนี้จากหน่วยงานอื่นมาฟ้องคดีตามภูมิลำเนา)
                            </th>
                            <th rowSpan="3" className='text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th colSpan="2" className='text-center'>
                                รับฟ้องตามภูมิลำเนา
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ยังไม่หมดอายุความ (ระบุเหตุผลที่ยังไม่ส่งฟ้อง)
                            </th>
                            <th rowSpan="3" className='text-center'>
                                หมดอายุความ (ให้ระบุว่าทำอะไรต่อ)
                            </th>
                            <th colSpan="3" className='text-center'>
                                ส่งต่อกรณีย้ายภูมิลำเนา
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ไม่พบข้อมูล
                            </th>
                        </tr>


                        <tr>
                            <th className='text-center'>
                                เลขที่หนังสือ
                            </th>
                            <th className='text-center'>
                                ลงวันที่
                            </th>
                            <th className='text-center'>
                                เลขที่หนังสือ
                            </th>
                            <th className='text-center'>
                                ลงวันที่
                            </th>
                            <th className='text-center'>
                                หน่วยงานที่ฟ้องคดีต่อ
                            </th>


                        </tr>

                    </thead>
                    <tbody>
                        {Re192027data.length > 0 && Re192027data.map((item, i) => (
                            <tr >
                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>
                                <td className='text-end'>
                                    {item.lawDept}
                                </td>
                                <td className='text-end'>
                                    {item.lawNo}
                                </td>
                                <td className='text-end'>
                                    {item.lawDate}
                                </td>
                                <td className='text-end'>
                                    {item.lawNotExpired}
                                </td>
                                <td className='text-end'>
                                    {item.lawExpired}
                                </td>
                                <td className='text-end'>
                                    {item.transferLawNo}
                                </td>
                                <td className='text-end'>
                                    {item.transferLawDate}
                                </td>
                                <td className='text-end'>
                                    {item.transferLawDept}
                                </td>
                                <td className='text-end'>
                                    {item.issue}
                                </td>
                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>

                </Table>
                {/* ส่งฟ้องคดีแล้ว */}
                <Table hidden={hidetable8} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="3" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="3" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="3" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินทำสัญญา
                            </th>

                            <th colSpan="5" className='text-center'>
                                ส่งฟ้องคดีแล้ว
                            </th>
                            <th rowSpan="3" className='text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th colSpan="2" className='text-center'>
                                ทำสัญญาประนีประนอมยอมความขั้นอัยการ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ส่งให้พนักงานอัยการฟ้องคดี (ศาลยังไม่รับฟ้อง)
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ศาลรับฟ้อง
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เลขคดีดำ
                            </th>

                        </tr>


                        <tr>
                            <th className='text-center'>
                                สำนักงานอัยการจังหวัด
                            </th>
                            <th className='text-center'>
                                วันที่
                            </th>

                        </tr>

                    </thead>
                    <tbody>
                        {Re192028data.length > 0 && Re192028data.map((item, i) => (
                            <tr >
                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>
                                <td className='text-end'>
                                    {item.compDebtContact}
                                </td>
                                <td className='text-end'>
                                    {item.compDebtContactDate}
                                </td>
                                <td className='text-end'>
                                    {item.transferJude}
                                </td>
                                <td className='text-end'>
                                    {item.court}
                                </td>
                                <td className='text-end'>
                                    {item.lawNo}
                                </td>


                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>

                </Table>
                {/* ศาลมีคำพิพากษาแล้ว */}
                <Table hidden={hidetable9} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="3" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="3" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="3" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินทำสัญญา
                            </th>

                            <th colSpan="9" className='text-center'>
                                ส่งฟ้องคดีแล้ว
                            </th>
                            <th rowSpan="3" className='text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th colSpan="3" className='text-center'>
                                รายละเอียดผลคำพิพากษา
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ลูกหนี้ชำระหนี้อยู่
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ยังไม่สืบทรัพย์
                            </th>
                            <th rowSpan="2" className='text-center'>
                                สืบทรัพย์/อยู่ระหว่างดำเนินการสืบทรัพย์
                            </th>
                            <th rowSpan="2" className='text-center'>
                                บังคับคดีแล้ว
                            </th>
                            <th rowSpan="2" className='text-center'>
                                อายุความ 10 ปี ยังไม่เสนอตัดหนี้สูญ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                พิพากษายกฟ้อง
                            </th>

                        </tr>


                        <tr>
                            <th className='text-center'>
                                เลขคดีแดง
                            </th>
                            <th className='text-center'>
                                วันที่
                            </th>
                            <th className='text-center'>
                                ศาลพิพากษา
                            </th>
                        </tr>

                    </thead>
                    <tbody>
                        {Re192029data.length > 0 && Re192029data.map((item, i) => (
                            <tr >
                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>
                                <td className='text-end'>
                                    {item.lawNo}
                                </td>
                                <td className='text-end'>
                                    {item.judeDate}
                                </td>
                                <td className='text-end'>
                                    {item.court}
                                </td>
                                <td className='text-end'>
                                    {item.debtPayment}
                                </td>
                                <td className='text-end'>
                                    {item.notInvestigate}
                                </td>
                                <td className='text-end'>
                                    {item.investigating}
                                </td>
                                <td className='text-end'>
                                    {item.law}
                                </td>
                                <td className='text-end'>
                                    {item.prescription10Years}
                                </td>
                                <td className='text-end'>
                                    {item.cancelJude}
                                </td>



                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>

                </Table>
                {/* ส่งฟ้องแล้วแต่ศาลไม่รับฟ้อง */}
                <Table hidden={hidetable10} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วงเงินทำสัญญา
                            </th>

                            <th colSpan="3" className='text-center'>
                                ส่งฟ้องแล้วแต่ศาลไม่รับฟ้อง เนื่องจาก
                            </th>
                            <th rowSpan="2" className='text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th className='text-center'>
                                อัยการแจ้งฐานะคดีไม่รับว่าต่าง
                            </th>
                            <th className='text-center'>
                                คณะกรรมการยุติการดำเนินคดีแพ่งของส่วนราชการ
                            </th>
                            <th className='text-center'>
                                ล้มละลาย
                            </th>
                        </tr>

                    </thead>
                    <tbody>
                        {Re1920210data.length > 0 && Re1920210data.map((item, i) => (
                            <tr >
                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>
                                <td className='text-end'>
                                    {item.attorney}
                                </td>
                                <td className='text-end'>
                                    {item.cancelCivilCase}
                                </td>
                                <td className='text-end'>
                                    {item.bankrupt}
                                </td>

                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>

                </Table>
                {/* อยู่ระหว่างขั้นตอนการขออนุมัติตัดหนี้สูญ */}
                <Table hidden={hidetable11} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วงเงินทำสัญญา
                            </th>

                            <th colSpan="8" className='text-center'>
                                อยู่ระหว่างขั้นตอนการขออนุมัติตัดหนี้สูญ
                            </th>
                            <th rowSpan="2" className='text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th className='text-center'>
                                เสียชีวิต
                            </th>
                            <th className='text-center'>
                                ศาลสั่งให้เป็นคนสาญสูญ
                            </th>
                            <th className='text-center'>
                                เจ็บป่วยเรื้อรัง
                            </th>
                            <th className='text-center'>
                                วิกลจริต
                            </th>
                            <th className='text-center'>
                                ทุพพลภาพ
                            </th>
                            <th className='text-center'>
                                พิพากษาอายุความครบ 10 ปี
                            </th>
                            <th className='text-center'>
                                ชำระหนี้มากกว่าหรือเท่ากับวงเงินกู้ยืม
                            </th>
                            <th className='text-center'>
                                มียอดค้างชำระไม่เกิน 40,000 บาท
                            </th>
                        </tr>

                    </thead>
                    <tbody>
                        {Re1920211data.length > 0 && Re1920211data.map((item, i) => (
                            <tr >
                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>

                                <td className='text-end'>
                                    {item.died}
                                </td>
                                <td className='text-end'>
                                    {item.disappear}
                                </td>
                                <td className='text-end'>
                                    {item.sick}
                                </td>
                                <td className='text-end'>
                                    {item.insane}
                                </td>
                                <td className='text-end'>
                                    {item.disability}
                                </td>
                                <td className='text-end'>
                                    {item.judement10Years}
                                </td>
                                <td className='text-end'>
                                    {item.paymentMoreLimit}
                                </td>
                                <td className='text-end'>
                                    {item.outstanding}
                                </td>


                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>

                </Table>
                {/* กรมบัญชีกลางอนุมัติตัดหนี้สูญแล้ว */}
                <Table hidden={hidetable12} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="3" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="3" className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th rowSpan="3" className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="3" className='text-center'>
                                วงเงินทำสัญญา
                            </th>

                            <th colSpan="10" className='text-center'>
                                กรมบัญชีกลางอนุมัติตัดหนี้สูญแล้ว
                            </th>
                            <th rowSpan="3" className='text-center'>
                                อื่นๆ (ให้ระบุ)
                            </th>
                            <th rowSpan="3" className='text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th colSpan="2" className='text-center'>
                                หนังสือหรมบัญชีกลาง
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เสียชีวิต
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ศาลสั่งให้เป็นคนสาญสูญ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เจ็บป่วยเรื้อรัง
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วิกลจริต
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ทุพพลภาพ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                พิพากษาอายุความครบ 10 ปี
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ชำระหนี้มากกว่าหรือเท่ากับวงเงินกู้ยืม
                            </th>
                            <th rowSpan="2" className='text-center'>
                                มียอดค้างชำระไม่เกิน 40,000 บาท
                            </th>

                        </tr>


                        <tr>
                            <th className='text-center'>
                                เลขที่
                            </th>
                            <th className='text-center'>
                                ลงวันที่
                            </th>

                        </tr>

                    </thead>
                    <tbody>
                        {Re1920212data.length > 0 && Re1920212data.map((item, i) => (
                            <tr >
                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.debtName}
                                </td>
                                <td className='text-end'>
                                    {item.comapanyNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveAmount}
                                </td>
                                <td className='text-end'>
                                    {item.contactAmount}
                                </td>
                                <td className='text-end'>
                                    {item.approveNo}
                                </td>
                                <td className='text-end'>
                                    {item.approveDate}
                                </td>
                                <td className='text-end'>
                                    {item.died}
                                </td>
                                <td className='text-end'>
                                    {item.disappear}
                                </td>
                                <td className='text-end'>
                                    {item.sick}
                                </td>
                                <td className='text-end'>
                                    {item.insane}
                                </td>
                                <td className='text-end'>
                                    {item.disability}
                                </td>
                                <td className='text-end'>
                                    {item.judement10Years}
                                </td>
                                <td className='text-end'>
                                    {item.paymentMoreLimit}
                                </td>
                                <td className='text-end'>
                                    {item.outstanding}
                                </td>

                                <td className='text-end'>

                                </td>
                                <td className='text-end'>
                                    <button
                                        type="button"
                                        className="btn border border-1 mx-1"
                                        onClick={() => { modalFileToggle1(!openModalFileForm1, setcomno1(item.comapanyNo)) }}
                                    >
                                        แก้ไข
                                    </button>
                                </td>
                            </tr>

                        ))}
                    </tbody>

                </Table>

                {/* เพิ่มใหม่ ตาม tor อันใหม่ */}

                <Table hidden={hidetable13} className="styled-table" bordered responsive striped hover>
                    <thead>
                        <tr>
                            <th className='text-center'>
                                ที่
                            </th>
                            <th className='text-center'>
                                ชื่อลูกหนี้
                            </th>
                            <th className='text-center'>
                                หน่วยงาน
                            </th>
                            <th className='text-center'>
                                เลขที่สัญญา
                            </th>
                            <th className='text-center'>
                                วงเงินที่ขอ
                            </th>
                            <th className='text-center'>
                                วงเงินอนุมัติ
                            </th>

                        </tr>

                    </thead>
                    <tbody>
                        {ReNewdata.length > 0 && ReNewdata.map((item, i) => (
                            <tr >
                                <td className='text-start'>
                                    {i + 1}
                                </td>
                                <td className='text-end'>
                                    {item.employee}
                                </td>
                                <td className='text-end'>
                                    {item.deptName}
                                </td>
                                <td className='text-end'>
                                    {item.contactNo}
                                </td>

                                <td className='text-end'>
                                    {NumberWithCommas(item.amountLimit)}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.approveAmount)}
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </Table>

            </div>
        </Container>
    );


}

